module.exports = __webpack_public_path__ + "img/CS.ca3f9d69.svg";